import Axios from 'axios'
import qs from 'qs';
import { Dialog,Toast } from 'vant';
if(process.env.NODE_ENV != "local"){//联调时用代理，不然跨域
  if(process.env.VUE_APP_NEW_PC){
    // 配置了VUE_APP_NEW_PC的环境，根据当前域名判断使用新域名还是旧域名
    const hostname = window.location.hostname;
    const newPcHosts = ['m.aiservhub.com', 'www.aiservhub.com', 'test.m.wankamall.com', 'test.wankamall.com'];
    Axios.defaults.baseURL = newPcHosts.includes(hostname) ? process.env.VUE_APP_NEW_PC : process.env.VUE_APP_PC;
  } else {
    Axios.defaults.baseURL = process.env.VUE_APP_PC;
  }
}
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
Axios.interceptors.request.use(config => {
  if(config.url.indexOf('/api/p/filings/electron/upload') != -1){
    config.headers['Content-Type'] = 'multipart/form-data';
    let formData = new FormData();
    for (let key in config.data) {
      formData.append(key, config.data[key])
    }
    config.data = formData
  }else{
    config.data = qs.stringify(config.data)
  }
  return config
})
// 添加响应拦截器
Axios.interceptors.response.use(response => {
  return response.data
}, error => {
  Toast.clear(true);
  switch (error.response.status) {
    case 403:
      Dialog({
        title: '提示',
        message:'禁止访问',
        confirmButtonText:'好的',
        confirmButtonColor:'#4285f5',
      })
      break;
    case 404:
      Dialog({
        title: '提示',
        message:'接口不存在',
        confirmButtonText:'好的',
        confirmButtonColor:'#4285f5',
      })
      break;
    case 405:
      Dialog({
        title: '提示',
        message:'不允许的HTTP请求方法',
        confirmButtonText:'好的',
        confirmButtonColor:'#4285f5',
      });
      break;
    case 500:
      Dialog({
        title: '提示',
        message:'服务器错误',
        confirmButtonText:'好的',
        confirmButtonColor:'#4285f5',
      }).then(() => {
        window.location.reload();
      });
      break;
    default:
      Dialog({
        title: '提示',
        message:'服务器连接异常，烦请客服' + error.response.status,
        confirmButtonText:'好的',
        confirmButtonColor:'#4285f5',
      });
      break;
  }
  return Promise.reject(error)
})
export default Axios
